import React from 'react';

export const PlayShaded = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 52.066 52.066" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Play_Icon" data-name="Play Icon" transform="translate(-46.967 -29.967)">
      <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(46.967 29.967)" fill="rgba(0,0,0,0.35)" stroke="#fff" strokeWidth="3">
        <circle cx="26.033" cy="26.033" r="26.033" stroke="none" />
        <circle cx="26.033" cy="26.033" r="24.533" fill="none" />
      </g>
      <path id="Path_1801" data-name="Path 1801" d="M0,0,21.074,14.076h0L0,27.686Z" transform="translate(65.562 42.364)" fill="#fff" />
    </g>
  </svg>
);